export default __webpack_public_path__ + "static/media/IconGreen.a61d68c1.svg";